<div class="flex flex-col gap-3">
  <div class="flex items-center justify-between px-[8px]">
    <h2 class="title text-[18px] font-semibold" i18n="@@breadcrumbRejectionReasons">Rejection Reasons</h2>

    <a
      routerLink="/admin/rejection-reasons/create-new-reason"
      class="add-button flex items-center justify-center gap-2">
      <span i18n="@@breadcrumbCreateNewReason">Create New Reason</span>
    </a>
  </div>

  <app-rejection-reason-list />
</div>